import { Box } from '@mui/material'
import React from 'react'
import '../assets/css/style.css'

function Footer() {
    return (
        <div>
            <Box id="footer" >
                Developed by Sirius Team
            </Box>
        </div>
    )
}

export default Footer
